import { render, staticRenderFns } from "./GestionePin.vue?vue&type=template&id=ebad9ba0&scoped=true"
import script from "./GestionePin.vue?vue&type=script&lang=js"
export * from "./GestionePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebad9ba0",
  null
  
)

export default component.exports